import { useTranslation } from 'react-i18next';
import { LaunchLoader } from '@/components/feedback/launch-loader';

export function PageLoading({ shell = false }: { shell?: boolean }) {
  const { t } = useTranslation('common');

  return (
    <div className={shell ? 'page-loading page-loading--shell' : 'page-loading'} aria-busy="true">
      <LaunchLoader label={t('status.loading')} compact={shell} />
    </div>
  );
}
